// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-dialog-filter {
  display: flex;
  flex-direction: column;
  width: 680px;
  height: 560px;
  max-height: 80vh;
  min-height: 300px;
}
.dl-dialog-filter__divider {
  margin: 0;
}
.dl-dialog-filter__body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 10px var(--_--side-padding);
}
.dl-dialog-filter__body_without-paddings {
  padding: 0;
}
.dl-dialog-filter__body_without-horizontal-paddings {
  padding: 10px 0;
}
.dl-dialog-filter__body_mode_fields {
  --dl-dataset-field-filter-padding: 0 32px;
}
.dl-dialog-filter__row {
  display: flex;
  margin-bottom: 10px;
}
.dl-dialog-filter__label {
  width: 100px;
  line-height: 28px;
}
.dl-dialog-filter__header-title-icon {
  flex-shrink: 0;
  margin-right: 5px;
}
.dl-dialog-filter__operation {
  display: flex;
  align-items: center;
  margin: 0 0 10px 32px;
}
.dl-dialog-filter__operation-label {
  margin-right: 40px;
}
.dl-dialog-filter__arrow-back-button {
  margin-right: 5px;
}
.dl-dialog-filter__load-limit-reached-warn {
  position: absolute;
  top: -20px;
  color: var(--g-color-text-hint);
  white-space: nowrap;
}
.dl-dialog-filter__loader {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}
.dl-dialog-filter .g-dialog-header__caption {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.dl-dialog-filter .g-dialog-body {
  overflow-y: auto;
}
.dl-dialog-filter .g-dialog-footer__children {
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/DialogFilter/DialogFilter.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;AACJ;AACI;EACI,SAAA;AACR;AAEI;EACI,cAAA;EACA,gBAAA;EACA,oCAAA;AAAR;AAEQ;EACI,UAAA;AAAZ;AAGQ;EACI,eAAA;AADZ;AAIQ;EACI,yCAAA;AAFZ;AAMI;EACI,aAAA;EACA,mBAAA;AAJR;AAOI;EACI,YAAA;EACA,iBAAA;AALR;AAQI;EACI,cAAA;EACA,iBAAA;AANR;AASI;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;AAPR;AAUI;EACI,kBAAA;AARR;AAWI;EACI,iBAAA;AATR;AAYI;EACI,kBAAA;EACA,UAAA;EACA,+BAAA;EACA,mBAAA;AAVR;AAaI;EACI,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AAXR;AAeI;EACI,gBAAA;EACA,mBAAA;EACA,uBAAA;AAbR;AAgBI;EACI,gBAAA;AAdR;AAiBI;EACI,kBAAA;AAfR","sourcesContent":[".dl-dialog-filter {\n  display: flex;\n  flex-direction: column;\n  width: 680px;\n  height: 560px;\n  max-height: 80vh;\n  min-height: 300px;\n}\n.dl-dialog-filter__divider {\n  margin: 0;\n}\n.dl-dialog-filter__body {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  padding: 10px var(--_--side-padding);\n}\n.dl-dialog-filter__body_without-paddings {\n  padding: 0;\n}\n.dl-dialog-filter__body_without-horizontal-paddings {\n  padding: 10px 0;\n}\n.dl-dialog-filter__body_mode_fields {\n  --dl-dataset-field-filter-padding: 0 32px;\n}\n.dl-dialog-filter__row {\n  display: flex;\n  margin-bottom: 10px;\n}\n.dl-dialog-filter__label {\n  width: 100px;\n  line-height: 28px;\n}\n.dl-dialog-filter__header-title-icon {\n  flex-shrink: 0;\n  margin-right: 5px;\n}\n.dl-dialog-filter__operation {\n  display: flex;\n  align-items: center;\n  margin: 0 0 10px 32px;\n}\n.dl-dialog-filter__operation-label {\n  margin-right: 40px;\n}\n.dl-dialog-filter__arrow-back-button {\n  margin-right: 5px;\n}\n.dl-dialog-filter__load-limit-reached-warn {\n  position: absolute;\n  top: -20px;\n  color: var(--g-color-text-hint);\n  white-space: nowrap;\n}\n.dl-dialog-filter__loader {\n  display: flex;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n}\n.dl-dialog-filter .g-dialog-header__caption {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.dl-dialog-filter .g-dialog-body {\n  overflow-y: auto;\n}\n.dl-dialog-filter .g-dialog-footer__children {\n  position: relative;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
